export default {
  methods: {
    mapLayerGroomingWinchAdd() {
      this.initPollGroomingWinch();
      this.map.addSource("grooming-winch-source", {
        type: "geojson",
        data: this.computedGroomingWinchGeoJson
      });

      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/grooming/winch/winch_icon_fixed.png",
        (error, image) => {
          this.map.addImage("icon-grooming-winch", image);
          this.map.addLayer({
            id: "grooming-winch",
            type: "symbol",
            source: "grooming-winch-source",
            layout: {
              "icon-image": "icon-grooming-winch",
              "icon-size": 0.1,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("grooming-winch", "marker-layer-points");
        }
      );

      this.map.addLayer({
        id: "grooming-winch-labels",
        type: "symbol",
        source: "grooming-winch-source",
        layout: {
          "text-field": "{a_number}",
          "text-anchor": "left",
          "text-allow-overlap": true,
          "text-offset": [1, 0],
          "icon-allow-overlap": true,
          "text-font": ["Open Sans Semibold"]
        },
        paint: {
          "text-color": [
            "case",
            ["==", ["get", "overall_anch_cond"], "Good"],
            "Green",
            ["==", ["get", "overall_anch_cond"], "Fair"],
            "Orange",
            ["==", ["get", "overall_anch_cond"], "Poor"],
            "Red",
            "Black"
          ],
          "text-halo-color": "lightgrey",
          "text-halo-width": 2
        }
      });
      this.map.moveLayer("grooming-winch-labels", "marker-layer-points");
    },
    mapLayerGroomingWinchRemove() {
      this.cancelPollGroomingWinch();
      this.map.removeImage("icon-grooming-winch");
      this.map.removeLayer("grooming-winch");
      this.map.removeLayer("grooming-winch-labels");
      this.map.removeSource("grooming-winch-source");
    },
    initPollGroomingWinch() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/grooming/winch",
        dept: "grooming",
        layer: "winch",
        token: this.computedAuthToken
      });
      this.pollGroomingWinchInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url: "https://api2.alchemymapping.com/vail/whistler/grooming/winch",
          dept: "grooming",
          layer: "winch",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollGroomingWinch() {
      this.pollGroomingWinchInterval = clearInterval(
        this.pollGroomingWinchInterval
      );
    }
  },
  computed: {
    computedGroomingWinchGeoJson() {
      return this.$store.state.mapLayers.grooming.layers.winch.geojson;
    },
    computedGroomingWinchMapVisibility() {
      return this.$store.state.mapLayers.grooming.layers.winch.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.grooming.layers.winch.geojson": {
      handler() {
        if (this.computedGroomingWinchGeoJson) {
          this.mapLayerGroomingWinchRemove();
          this.mapLayerGroomingWinchAdd();
        }
      }
    },
    "$store.state.mapLayers.grooming.layers.winch.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerGroomingWinchAdd();
      } else {
        this.mapLayerGroomingWinchRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollGroomingWinch();
  }
};
